import { AutocompleteFormComponent } from "components/Form/components/Autocomplete/AutocompleteFormComponent";
import { useWorkspaceConfigValue } from "containers/WorkspaceConfig/useWorkspaceConfigValue";
import { SavepointRetention } from "graphql/generated/graphql";
import { Field } from "react-final-form";

export const SavePointRetentionField = ({
    initialValue,
    isDisabled,
    onChange,
}: {
    initialValue: SavepointRetention | null;
    isDisabled?: boolean;
    onChange: () => void;
}) => {
    const savePointDefaultRetention = useWorkspaceConfigValue("SAVEPOINT_RETENTION");
    return (
        <Field name="savepoint_retention" id="savepoint_retention" initialValue={initialValue}>
            {({ input }) => (
                <AutocompleteFormComponent
                    input={{
                        ...input,
                        name: "savepoint_retention",
                        onChange: (value) => {
                            input.onChange(value);
                            onChange();
                        },
                    }}
                    fieldProps={{
                        options: { enumName: "SavepointRetention" },
                        defaultValue: {
                            icon: null,
                            label: `${savePointDefaultRetention} (workspace-wide savepoint retention) `,
                            value: null,
                        },
                        docs: {
                            urlPath: "/docs/savepoints#savepoint-lifetime",
                        },
                        fieldWidth: 300,
                    }}
                    meta={{}}
                    fieldAttr={{
                        disabled: isDisabled,
                    }}
                />
            )}
        </Field>
    );
};
